import { LightUserStateModel } from './light-user-state.model';

export interface PeopleToFollowState {
  peopleState: LightUserStateModel[];
  loading: boolean;
  error: string;
}

export const initialPeopleToFollow: PeopleToFollowState = {
  peopleState: [],
  loading: false,
  error: ''
};
